import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import responsiveReducer from './slices/responsiveSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    responsive: responsiveReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;

export default store;
